import { Injectable, OnInit } from "@angular/core";
import {
	CanActivate,
	Router,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { Role } from "../models/role";

@Injectable({
	providedIn: "root",
})
export class RoleGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) {
		console.log(">>RoleGuard.constructor()::");
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		let url: string = state.url;
		console.log(">>RoleGuard.canActivate():: url: %s", url);
		// Se cargan los roles del usuario y luego se hace el checkeo de si puede entrar a la URL requerida
		return new Observable<boolean>((observer) => {
			console.log(">> RoleGuard::canActivate() - Inicio");
			let userName = this.authService.getUsername();
			this.authService.getUserRoles(userName).subscribe(
				(responseUsrRoles: any) => {
					this.authService.getUser().roles = [];
					if(responseUsrRoles && responseUsrRoles.perfiles){
						for (let i = 0; i < responseUsrRoles.perfiles.length; i++) {
							const element = responseUsrRoles.perfiles[i];
							this.authService.getUser().roles.push(element);
						} //for
					}
					let checkRole = this.checkRole(url, route);
					observer.next(checkRole);
					observer.complete();
				},
				(err) => {
					console.log(err);
					observer.next(false);
					observer.complete();
				}
			);
		});
	}


	/**
	 * Valida el Role que tiene el usuario
	 */
	checkRole(url: string, route: ActivatedRouteSnapshot): boolean {
		console.log(">> RoleGuard::checkRole() - Inicio");
		let user = this.authService.getUser();

		let autorizado = false;

		if (route.data.roles.indexOf(Role.Anyone) >= 0) {
			console.log("RoleGuard.checkRole():: Habilitado acceso ANYONE");
			// Si esta configurado para que acceda cualquiera
			autorizado = true;
		} else {
			if (route.data.roles && user.roles) {
				// Si no esta configurado para que acceda cualquiera, recorre cada rol otorgado al usuario, fijándose si alguno de estos 
				// está en la lista de los roles habilitados
				for (let role of user.roles) {
					if (route.data.roles.indexOf(role) >= 0) {
						// indexOf retorna -1 si no lo encuentra
						console.log("RoleGuard.checkRole():: encontramos Role %s en lista", role);
						// hay match entre el conjunto de roles habilitados para la ruta y los roles del usuario
						autorizado = true;
						break;
					}
				}
			}
		}
        autorizado = true;
		console.log("RoleGuard.checkRole():: autorizado: %s , route.data.roles: %s , user.roles: %s", autorizado, JSON.stringify(route.data.roles), JSON.stringify(user.roles));
		if (!autorizado) {
			if (this.authService.isLoggedIn
			) {
				this.router.navigate(["/config/not-authorized"]);
				this.authService.logout();
			} else {
				// Si todavia no le logueo lo envio al login
				this.router.navigate(["/login"]);
			}

			return false;
		} else {
			return true;
		}
	}
}